__turbopack_context__.v({
  "contentLayout": "Author-module-scss-module__1DJ1WG__contentLayout",
  "mainLayout": "Author-module-scss-module__1DJ1WG__mainLayout",
});
